import React, { useEffect } from 'react'

import { Box, Center, Flex, Text } from '@chakra-ui/react'
import { useLocalCameraTrack } from 'agora-rtc-react'
import { VideoCallRoomControl } from 'src/features/videoCall/components/VideoCallRoomControl/VideoCallRoomControl'
import { VideoCallRoomMainContent } from 'src/features/videoCall/components/VideoCallRoomMainContent/VideoCallRoomMainContent'
import { useLocalPlayer } from 'src/features/videoCall/context/localPlayerContext'
import { useVideoCallRoom } from 'src/features/videoCall/context/videoCallRoomContext'

import { useRoomMediaContext } from '../../context/MediaProvider'

type Props = {
  canShareScreen: boolean
  sendNotification: () => void
}

export const ExplanationRoomLobbyVideoCallContent: React.FC<Props> = ({
  canShareScreen,
  sendNotification,
}) => {
  const { isForcedExitByOtherDevice } = useVideoCallRoom()
  const { setShowMediaNotEnabledPopover } = useRoomMediaContext()

  const { localMicrophoneTrack } = useLocalPlayer()
  const { localCameraTrack } = useLocalCameraTrack()

  useEffect(() => {
    if (localMicrophoneTrack || localCameraTrack) {
      setShowMediaNotEnabledPopover(false)
    }
  }, [localMicrophoneTrack, localCameraTrack, setShowMediaNotEnabledPopover])

  if (isForcedExitByOtherDevice) {
    return <ForcedExit />
  }

  return (
    <Flex boxSize="full" bg="black" direction="column">
      <Box boxSize="full">
        <VideoCallRoomMainContent
          endedText="ビデオ通話は終了しました"
          colorScheme="green"
          sendNotification={sendNotification}
        />
      </Box>
      <Box h="80px" w="full">
        <VideoCallRoomControl
          colorScheme="green"
          bgColor="gray.100"
          canLeaveRoom={false}
          canShareScreen={canShareScreen}
        />
      </Box>
    </Flex>
  )
}

const ForcedExit: React.FC = () => {
  return (
    <Center boxSize="full">
      <Text fontWeight="bold">
        他の端末でビデオ通話が開始されたため退出しました。
      </Text>
    </Center>
  )
}
